<template>
    <li>
        <div class="title"><span>拠点または生産地</span></div>
        <div class="detail">
            <p><span>{{ this.$store.state.register.form.base }}</span></p>
        </div>
    </li>
</template>

